export const MuiTooltip = {
	styleOverrides: {
		tooltip: ({ theme }) => {
			return {
				backgroundColor: theme.palette.secondary.main,
			};
		},
	},
};
